import Url from '@/components/mixins/Url'
import Brands from '@/components/mixins/Brands'

export default {
  mixins: [
    Url,
    Brands
  ],

  computed: {
    showparticipantlogo () {
      return this.current_brand_cnfiguration.showParticipantLogos
    },

    teamLogoVisibility () {
      return Boolean(this.teamLogos.logoHome || this.teamLogos.logoAway || this.teamLogos.logo)
    },

    awayTeamLogoStyle () {
      return this.teamLogoVisibility ? this.styleObject(this.teamLogos.logoAway) : {}
    },

    homeTeamLogoStyle () {
      return this.teamLogoVisibility ? this.styleObject(this.teamLogos.logoHome) : {}
    },

    teamLogoStyle () {
      return this.teamLogoVisibility ? this.styleObject(this.teamLogos.logo) : {}
    }
  },

  methods: {
    teamLogoPath (filename) {
      var path = ''

      if (filename) {
        filename = filename.trim()

        if (filename.charAt(0) === '/') {
          filename = filename.substring(1)
        }
        if (filename.indexOf('http://') > -1 || filename.indexOf('https://') > -1) {
          path = encodeURI(filename)
        } else {
          path = this.teamLogoHostname + '/' + encodeURI(filename)
        }
      }
      return path
    },

    styleObject (filename) {
      return filename ? { backgroundImage: 'url(' + this.teamLogoPath(filename) + ')' }
      : {}
    }
  },

  created () {

  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/TeamLogo.js